import type * as React from 'react';

function SvgNHL(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        clipRule="evenodd"
        d="M2 16H5.978H5.97867C6.66667 16 7.29733 15.6533 7.66667 15.0713L15.7667 2.30267C15.9187 2.06333 16 1.78533 16 1.5C16 0.673333 15.3267 0 14.5 0C14.0233 0 13.5713 0.228667 13.29 0.614L4.944 12H2C0.896667 12 0 12.8973 0 14C0 15.1027 0.896667 16 2 16ZM1 14C1 13.448 1.44933 13 2 13H3V15H2C1.44933 15 1 14.552 1 14ZM5.978 15H4V13H4.944C5.26 13 5.562 12.848 5.75 12.592L7.14318 10.6914L8.60865 11.7206L6.82333 14.5347C6.638 14.826 6.322 15 5.978 15ZM9.14495 10.8753L7.7345 9.88471L8.59502 8.71078L9.88394 9.71049L9.14495 10.8753ZM10.4228 8.86119L14.9233 1.76733C14.974 1.68733 15 1.59733 15 1.5C15 1.224 14.7753 1 14.5 1C14.3393 1 14.192 1.07533 14.0967 1.20533L9.18723 7.90288L10.4228 8.86119ZM0.5 10H4.5C4.776 10 5 9.776 5 9.5V7.5C5 7.224 4.776 7 4.5 7H0.5C0.224 7 0 7.224 0 7.5V9.5C0 9.776 0.224 10 0.5 10ZM4 9H1V8H4V9Z"
        fill="#656565"
        fillRule="evenodd"
      />
    </svg>
  );
}

export default SvgNHL;
